<template>
    <div class="brder-b title">
        {{name}}
    </div>
</template>
<script>
export default {
    props:{
        name: {
        type: String,
        default: ''
        },
    },
    data(){
        return{

        }
    }
}
</script>
<style lang="scss" scoped>
    .title{
        height: 62px;
        font-size:30px;
        color:$color-51;
        line-height:70px;
        margin: 0 20px;
        padding-left: 16px;
        &::before{
            content: '';
            width:4px;
            height:20px;
            display: inline-block;
            margin-right: 17px;
            background:$color-176;
        }
    }
</style>


